<script setup lang="ts"></script>

<template>
  <div class="w-full p-6 relative">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@media (min-width: 768px) {
  div {
    @apply shadow;
    background-color: var(--m-light);
    border-radius: 0.5rem;
    padding-top: 77px;
    padding-bottom: 77px;
  }
}
</style>
